import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react';
import {persistor, store} from './state/store';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import './index.css';
import 'react-responsive-modal/styles.css';
import "react-datepicker/dist/react-datepicker.css";
const history = createBrowserHistory();
Sentry.init({ dsn: "https://8139982dcf1b473e8df3f359bcdcfb6c@o870048.ingest.sentry.io/5825864" });

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* redux persist */}
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history}>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
